export default process.env.API_ENV || 'development'
